import React from 'react';
import { InputWrapper, Select } from 'form/components';
import { Heading, Text } from 'lmc-ui-library-rebrand';

type Props = {
  title: string;
  name: string;
};

const FindDefault: React.FC<Props> = ({ title, name }) => {
  return (
    <>
      <Heading mode="subheading" weight="bold" style={{ marginBottom: '14px' }}>
        Choose a network/club
      </Heading>
      <Text color="var(--color-indigo-t11)">Please select an option above</Text>

      <InputWrapper title={title} name={name} newUi>
        <Select options={[]} newUi />
      </InputWrapper>
    </>
  );
};

export default FindDefault;
